<form #countryPhoneSelectForm="ngForm">
  <div class="flex flex-column gap-2">
    <p class="text-sm text-color font-normal">{{ 'phone_number' | transloco }}</p>
    <div class="flex flex-column sm:flex-row gap-3">
      <div class="flex flex-column gap-2 w-auto">
        <p-select
          name="country"
          [options]="countries()"
          [(ngModel)]="selectedCountry"
          optionLabel="name"
          [filter]="true"
          filterBy="name,code,dialCode,dial_code"
          placeholder="Select a Country"
          (ngModelChange)="onCountryChange($event)"
          class="w-full md:w-10rem"
          panelStyleClass="w-full md:w-10rem"
          appendTo="body"
        >
          <!-- Selected -->
          <ng-template #selectedItem let-selectedOption>
            @if (selectedOption) {
              <div class="flex align-items-center gap-2">
                <span class="text-lg flex-shrink-0">{{ selectedOption.flag }}</span>
                <div class="flex-1 overflow-hidden">{{ selectedOption.code }} ({{ selectedOption.dialCode }})</div>
              </div>
            }
          </ng-template>

          <!-- Dropdown item -->
          <ng-template let-country #item>
            <div class="flex align-items-center gap-2">
              <span class="text-lg flex-shrink-0">{{ country.flag }}</span>
              <div class="flex-1 overflow-hidden">({{ country.code }}) {{ country.dialCode }}</div>
            </div>
          </ng-template>
        </p-select>
      </div>
      <div class="flex flex-column gap-2 w-full">
        <input
          pInputText
          id="phone"
          name="phone"
          class="w-full"
          [ngModel]="phone()"
          (ngModelChange)="onPhoneInput($event)"
          (keypress)="allowOnlyNumbers($event)"
          [maxlength]="maxLength()"
          autoComplete="off"
        />
      </div>
    </div>
    <!-- [placeholder]="placeholder()" -->
    <!-- @if (isValid()) {
      <div style="color: green">✅ Valid</div>
    }

    @if (!isValid()) {
      <div style="color: red">❌ Invalid</div>
    } -->
  </div>
</form>
